/* eslint-disable no-array-constructor */

function idNumber (idCard) {
  if (!idCard) {
    return false
  }
  idCard = idCard.trim()
  // 18位身份证号码的正则表达式
  const regIdCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/
  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(idCard)) {
    const idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 将前17位加权因子保存在数组里
    const idCardY = ['1', '0', '10', '9', '8', '7', '6', '5', '4', '3', '2'] // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
    let idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
    for (let i = 0; i < 17; i++) {
      idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i]
    }

    const idCardMod = idCardWiSum % 11// 计算出校验码所在数组的位置
    const idCardLast = idCard.substring(17)// 得到最后一位身份证号码

    // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
    if (idCardMod === 2) {
      if (idCardLast === 'X' || idCardLast === 'x') {
        return true
      }
    } else {
      // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
      if (idCardLast === idCardY[idCardMod]) {
        return true
      }
    }
  }
  console.log("idCard2:"+idCard)
  return false
}
export default {
  phone (val) {
    const reg = /(^1\d{10}$)/
    if (reg.test(val)) {
      return true
    }
    return false
  },
  idNumber,
  // 通过身份证号验证指定年龄
  idNumberValidator(idCard,older) {
    if (idNumber(idCard)) {
      //获取年龄
      const myDate = new Date();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      let age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
      if (idCard.substring(10, 12) < month || idCard.substring(10, 12) == month && idCard.substring(12, 14) <= day) {
        age++;
      }
      if (age >= older) {
        return false
      }
      return true
    } else {
      console.log("idCard1");
      return false
    }
  },
  password (pwd) {
    // 8-16位字符,字母(区分大小写)和数字组合'
    const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
    if (reg.test(pwd)) {
      return true
    }
    return false
  },
  code (val) {
    const reg = /^\d{6}$/
    if (reg.test(val)) {
      return true
    }
    return false
  },
  mobile_phone (str) {
    if (!str) {
      return false
    }
    str = str.trim()
    if (str !== '') {
      const reg = /(^1[3|4|5|6|7|8|9]\d{9}$)/
      if (reg.test(str)) {
        return true
      }
    }
    return false
  },
  loginName (val) {
    if (!val) {
      return false
    }
    const reg = /^[a-z|A-Z]{1}[0-9A-Za-z]{5,14}$/
    return reg.test(val)
  },
  loginNameTmp (val) {
    if (!val) {
      return false
    }
    const reg = /^[a-z]{2,5}$/
    return reg.test(val)
  },
  playerNumber (val) {
    if (!val) {
      return false
    }
    const reg = /^[0-9]{1,2}$/
    return reg.test(val)
  },
  checkPassport (val) {
    // 护照
    // const g = /^[a-zA-Z]{5,17}$/;
    const reg = /^[a-zA-Z0-9]{5,17}$/;
    return reg.test(val)
  },
  checkTaiwOld (val) {
    // 台湾通行证
    const reg = /^[0-9]{8}$/;
    return reg.test(val)
  },
  checkHkongMacao (val) {
    // 港澳通行证
    const reg = /^[HMhm]{1}([0-9]{8})$/;
    return reg.test(val)
  },
  checkWork (val) {
    // 外国人居留证
    const reg = /^[a-zA-Z]{3}[0-9]{12}$/;
    return reg.test(val)
  },
  checkEmail (val) {
    // 邮箱
    const reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
    return reg.test(val)
  },
  isNumber (val) {
    if (!val && val !==0  ) {
      return false
    }
    const reg = /^[0-9]+$/
    return reg.test(val)
  },
}
